import { dataProviderOptions } from './KidsPlan.consts';
import { KidsSetting } from './KidsPlan.types';

export const providerIds = dataProviderOptions.map((opt) => opt.id) as string[];

export const mapSettingsToDefaultValues = (
  providerGroups: { settings?: KidsSetting[] }[] = []
) => {
  return providerGroups.reduce<Record<string, string>>((acc, group) => {
    group.settings?.forEach(({ key, value }) => {
      acc[key] = value ?? '';
    });
    return acc;
  }, {});
};
